export default __webpack_public_path__ + "static/media/delete.f53f3125.svg";